import EternaVault from '../components/EternaVault';

export default function Home() {
  return (
    <div className="page-home">
      <EternaVault />
    </div>
  );
}
